import React, { useEffect, useState, useRef, Alert } from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link } from 'react-router-dom';
import api from '../../axiosConfig';
import Modal from 'bootstrap/js/dist/modal';
import AsyncSelect from 'react-select/async';
import Select from 'react-select';
import FileViewerModal from './FileViewerModal';
import { useNotification } from '../utils/NotificationProvider';
import useResponsiveTable from '../../hook/useResponsiveTable';
import { requestNotificationsRefresh } from '../../masterLayout/NotificaionGui';


export default function TablaComprobantesTrabajador() {

    const [data, setData] = useState([]);
    const { tableRef, containerClass } = useResponsiveTable([data]); // pasa tu array de filas
    const [total, setTotal] = useState(0);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [editingUser, setEditingUser] = useState(null);
    const [selectedEmpleado, setSelectedEmpleado] = useState(null);
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');
    const [open, setOpen] = useState(false);
    const [exampleBase64PDF, setExampleBase64PDF] = useState('');
    const [todo, setTodo] = useState(false);

    const [origen, setOrigen] = useState('');
    const [s3Link, setS3Link] = useState('');

    const [fileType, setFileType] = useState('');
    const [fileName, setFileName] = useState('');

    const [isXml, setIsXml] = useState(false);
    const [isCfdi, setIsCfdi] = useState(false);
    const [isRecibo, setIsRecibo] = useState(false);

    const [selectedRoles, setSelectedRoles] = useState([]);

    const [selectedIds, setSelectedIds] = useState([]);

    const toggleCheckbox = (idUsuario) => {
        setSelectedIds((prev) =>
            prev.includes(idUsuario)
                ? prev.filter((id) => id !== idUsuario)
                : [...prev, idUsuario]
        );
    };

    const { notify } = useNotification();

    const getSelectedIds = () => {
        console.log('Seleccionados:', selectedIds);
        return selectedIds;
    };
    function formatearFechaLarga(fechaIso) {
        try {
            const fecha = new Date(fechaIso);
            const opciones = { day: '2-digit', month: 'long', year: 'numeric' };
            const formateada = new Intl.DateTimeFormat('es-ES', opciones).format(fecha);
            return formateada.charAt(0).toUpperCase() + formateada.slice(1);
        } catch (err) {
            return ''
        }
    }

    function formatearMoneda(valor) {
        return new Intl.NumberFormat('es-MX', {
            style: 'currency',
            currency: 'MXN',
            minimumFractionDigits: 2,
        }).format(valor);
    }

    const getRar = async (tipo) => {

        /*
        let json = {
            "tipo": tipo,
            "list": getSelectedIds()
        }
        */

        let json = {
            "tipo": tipo,
            "s3Keys": getSelectedIds()
        }


        console.log("json", json)

        try {

            let hostApi = "";

            if (todo) { 
                hostApi = `/comprobantes/zipAllEmpleado?inicio=${(page - 1) * limit}&longitud=${limit}&orden=desc&ordenColumn=rfc&cadena=${search}&noEmpleado=0&fechaInicio=${fechaInicio}&fechaFin=${fechaFin}&tipo=${tipo}`;
                json = null;
            } else {
                //hostApi = `/comprobantes/zip`;
                hostApi = `/api/downloads/s3`;
            }


            const res = await api.post(hostApi, json, {
                //responseType: 'Aplication/json', // 👈 importante para manejar archivos binarios
                //responseType: 'blob', // 👈 importante para manejar archivos binarios
            });

            notify("Solicitud de descarga creada exitosamente puedes validar el estado en notificaciones, se te enviara un correo cuando este disponible para la descarga.", "info");
            requestNotificationsRefresh();

            /*
            const blob = new Blob([res.data], { type: 'application/zip' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');

            a.href = url;
            a.download = `comprobantes_${tipo}.zip`; // nombre del archivo descargado
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
            */



        } catch (err) {

            console.error("Error al descargar ZIP:", err);
            if (err.status == 409) {
                notify(" Tienes demasiadas descargas en proceso. Intenta más tarde.", "error")
            }else if (err.status == 402) {
                    notify("Solo es posible descargar de 1 a 72 archivos.", "info")
            } else {
                notify(" Ocurrio un error al procesar la solicitud : " + err.message, "error")
            }


        }


    }

    //const exampleBase64PDF = 'data:application/pdf;base64,...'; // reemplaza con tu base64 real



    useEffect(() => {
        getDatos();
    }, [page, limit, search]);



    useEffect(() => {
        setPage(1);
        console.log("set page to ", 1)
        getDatos();
    }, [fechaFin, fechaInicio]);


    const getComprobante = async (tipo, id) => {

        try {
            const res = await api.get(`/comprobantes/${tipo}/${id}`)
            if (res.status === 200 && (res.data.base64 != null || res.data.linkS3 != null)) {

                console.log("res.data", res.data)

                //setExampleBase64PDF(res.data.base64)
                setFileName(`${getValue('folio')}.${tipo == 'xml' ? 'xml' : 'pdf'}`)
                setFileType(`application/${tipo == 'xml' ? 'xml' : 'pdf'}`)
                //setOpen(true)

                setS3Link(res.data.linkS3)
                setOrigen(res.data.tipoRespuesta)
                setExampleBase64PDF(res.data.base64)

                if (res.data.tipoRespuesta == "s3") {
                    //setExampleBase64PDF(res.data.linkS3)
                    setOpen(true)
                } else {
                    //setExampleBase64PDF(res.data.base64)
                    setOpen(true)
                }

            } else {
                console.error("Error: respuesta no exitosa", res.status);
                //alert("Documento no encontrado");
                notify("Documento no encontrado.", "info")
            }

        } catch (err) {
            console.error("Error al obtener datos:", err);
            notify(" Ocurrio un error al procesar la solicitud : " + err.message, "error")
        }

    }


    const getDatos = async () => {
        try {
            const res = await api.get(
                `/comprobantes/table?inicio=${(page - 1) * limit}&longitud=${limit}&orden=desc&ordenColumn=fecha_pago&cadena=${search}&fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`
            );
            setData(res.data.data);
            //setTotal(res.data.recordsTotal);
            setTotal(res.data.recordsFiltered);
        } catch (err) {
            console.error("Error al obtener datos:", err);
            notify(" Ocurrio un error al procesar la solicitud : " + err.message, "error")
        }
    };

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
        setPage(1);
    };



    const handleEdit = async (user) => {
        setEditingUser(user);


        try {
            const res = await api.get(`/comprobantes/disponibilidad/${user.folio}`)
            if (res.status === 200) {

                console.log("res.data", res.data)

                setIsXml(res.data?.XML)
                setIsCfdi(res.data?.CFDI)
                setIsRecibo(res.data?.RECIBO)

            } else {
                console.error("Error: respuesta no exitosa", res.status);
                //alert("Documento no encontrado");
                notify("Documento no encontrado.", "info")
            }

        } catch (err) {
            console.error("Error al obtener datos:", err);
            notify(" Ocurrio un error al procesar la solicitud : " + err.message, "error")
        }


        const modal = new Modal(document.getElementById('exampleModal'));
        modal.show();
    };

    const totalPages = Math.ceil(total / limit);

    const getValue = (key, fallback = '') => editingUser?.[key] ?? fallback;


    const renderFooter = () => {
        return (
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
                <span>Mostrando {data.length} de {total} Registros</span>
                <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                    {/* Botón anterior */}
                    <li className="page-item">
                        <button
                            className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md"
                            onClick={() => page > 1 && setPage(page - 1)}
                            disabled={page === 1}
                        >
                            <Icon icon="ep:d-arrow-left" />
                        </button>
                    </li>

                    {/* Calcular rango de páginas */}
                    {(() => {
                        const pagesToShow = 5;
                        let startPage = Math.max(1, page - Math.floor(pagesToShow / 2));
                        let endPage = startPage + pagesToShow - 1;

                        if (endPage > totalPages) {
                            endPage = totalPages;
                            startPage = Math.max(1, endPage - pagesToShow + 1);
                        }

                        const pageNumbers = [];
                        for (let i = startPage; i <= endPage; i++) {
                            pageNumbers.push(i);
                        }

                        return pageNumbers.map((num) => (
                            <li className="page-item" key={num}>
                                <button
                                    className={`page-link fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md ${page === num
                                        ? "bg-primary-600 text-white"
                                        : "bg-neutral-200 text-secondary-light"
                                        }`}
                                    onClick={() => setPage(num)}
                                >
                                    {num}
                                </button>
                            </li>
                        ));
                    })()}

                    {/* Botón siguiente */}
                    <li className="page-item">
                        <button
                            className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md"
                            onClick={() => page < totalPages && setPage(page + 1)}
                            disabled={page === totalPages}
                        >
                            <Icon icon="ep:d-arrow-right" />
                        </button>
                    </li>
                </ul>
            </div>
        )
    }


    return (
        <>

            <div className="col-lg-12">
                <div className="card">
                    <div className="card-header">
                        <h5 className="card-title mb-0">Filtros</h5>
                    </div>
                    <div className="card-body">
                        <form className="row gy-3 needs-validation" noValidate="">


                            <div className="col-md-6">
                                <label className="form-label">Fecha inicio</label>
                                <div className="d-flex gap-2">
                                    <input
                                        type="date"
                                        name="fechaInicio"
                                        className="form-control"
                                        value={fechaInicio || ""}
                                        onChange={(e) => setFechaInicio(e.target.value)}
                                    />
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary"
                                        onClick={() => setFechaInicio("")}
                                    >
                                        Limpiar
                                    </button>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <label className="form-label">Fecha fin</label>
                                <div className="d-flex gap-2">
                                    <input
                                        type="date"
                                        name="fechaFin"
                                        className="form-control"
                                        value={fechaFin || ""}
                                        onChange={(e) => setFechaFin(e.target.value)}
                                    />
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary"
                                        onClick={() => setFechaFin("")}
                                    >
                                        Limpiar
                                    </button>
                                </div>
                            </div>


                        </form>
                    </div>
                </div>
            </div>

            <div className="card h-100 p-0 radius-12">
                <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                    <div className="d-flex align-items-center flex-wrap gap-3">
                        <span className="text-md fw-medium text-secondary-light mb-0">Mostrar</span>
                        <select
                            className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
                            value={limit}
                            onChange={(e) => setLimit(parseInt(e.target.value))}
                        >
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={50}>50</option>
                        </select>
                        <form className="navbar-search">
                            <input
                                type="text"
                                className="bg-neutra h-40-px w-auto"
                                name="search"
                                placeholder="Buscar"
                                value={search}
                                onChange={handleSearchChange}
                            />
                            <Icon icon="ion:search-outline" className="icon" />
                        </form>
                    </div>


                    <div className="dropdown">
                        <button
                            className="btn text-primary-600 hover-text-primary px-18 py-11 dropdown-toggle toggle-icon"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            {" "}
                            Descargar Sel.{" "}
                        </button>
                        <ul className="dropdown-menu">
                            <li>
                                <Link
                                    className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                    to="#"
                                    onClick={(e) => getRar("cfdi")} >
                                    CFDI
                                </Link>
                            </li>
                            <li>
                                <Link
                                    className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                    to="#"
                                    onClick={(e) => getRar("xml")} >
                                    XML
                                </Link>
                            </li>
                            <li>
                                <Link
                                    className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                    to="#"
                                    onClick={(e) => getRar("recibo")} >
                                    Recibo
                                </Link>
                            </li>
                            <li>
                                <Link
                                    className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                    to="#"
                                    onClick={(e) => getRar("todo")} >
                                    Todo
                                </Link>
                            </li>
                        </ul>
                    </div>


                </div>
                <div className="card-body p-24">
                    <div className={`table-responsive scroll-sm ${containerClass}`}>
                        <table ref={tableRef} className="table bordered-table sm-table mb-0">
                            <thead>
                                <tr>
                                    <th scope="col">
                                        {/*  <div className="form-check style-check d-flex align-items-center">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                onChange={(e) => setTodo(e.target.checked)} />
                                        </div>*/}
                                    </th>
                                    <th scope="col">No. factura</th>
                                    <th scope="col">Fecha pago</th>
                                    <th scope="col" className="text-center">Estatus</th>
                                    <th scope="col" >Total pagado</th>
                                    <th scope="col" className="text-center">Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((e) => (
                                    <tr key={e.id}>
                                        <td>
                                            <div className="form-check style-check d-flex align-items-center">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    checked={selectedIds.includes(e.id)}
                                                    onChange={() => toggleCheckbox(e.id)}
                                                    hidden={todo}
                                                />

                                            </div>
                                        </td>
                                        <td>{e.folio}</td>

                                        <td>{formatearFechaLarga(e.fechaPago)}</td>
                                        <td className="text-center" >{e.estatus == "E" ?
                                            <span className="bg-success-focus text-success-600 border border-success-main px-24 py-4 radius-4 fw-medium text-sm">
                                                Timbrado
                                            </span> :
                                            (e.estatus == "I" ?
                                                <span className="bg-warning-focus text-warning-600 border border-warning-main px-24 py-4 radius-4 fw-medium text-sm">
                                                    Incidencia
                                                </span> :
                                                <span className="bg-info-focus text-info-600 border border-info-main px-24 py-4 radius-4 fw-medium text-sm">
                                                    Solicitado
                                                </span>
                                            )
                                        }</td>
                                        <td>{formatearMoneda(e.neto)}</td>

                                        <td className="text-center">
                                            <div className="d-flex align-items-center gap-10 justify-content-center">
                                                <button
                                                    type="button"
                                                    className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                    onClick={() => handleEdit(e)} >
                                                    <Icon icon="lucide:eye" className="menu-icon" />
                                                </button>


                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {renderFooter()}

                </div>
            </div>


            {/* Modal */}
            <div className="modal fade" id="exampleModal" tabIndex={-1} aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content radius-16 bg-base">
                        <div className="modal-header py-16 px-24 border-bottom">
                            <h5 className="modal-title">
                                Comprobante
                            </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body p-24">
                            {/* <form onSubmit={handleSubmit}> */}
                            <div className="row">

                                <div className="col-6 mb-20">
                                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                                        No. Factura
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control radius-8"
                                        placeholder="Enter Role  Name"
                                        value={getValue("folio")}
                                        disabled={true}
                                    />
                                </div>

                                <div className="col-6 mb-20">
                                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                                        Fecha Pago
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control radius-8"
                                        placeholder="Enter Role  Name"
                                        value={formatearFechaLarga(getValue("fechaPago"))}
                                        disabled={true}
                                    />
                                </div>



                                <div className="col-6 mb-20">
                                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                                        RFC
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control radius-8"
                                        placeholder="Enter Role  Name"
                                        value={getValue("rfc")}
                                        disabled={true}
                                    />
                                </div>


                                <div className="col-6 mb-20">
                                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                                        No. Empleado
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control radius-8"
                                        placeholder="Enter Role  
                                            Name"value={getValue("noEmpleado")}
                                        disabled={true}
                                    />
                                </div>


                                <div className="col-6 mb-20">
                                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                                        Nombre
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control radius-8"
                                        placeholder="Enter Role  Name"
                                        value={getValue("nombre")}
                                        disabled={true}
                                    />
                                </div>


                                <div className="col-6 mb-20">
                                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                                        Total Pagado
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control radius-8"
                                        placeholder="Enter Role  Name"
                                        value={formatearMoneda(getValue("neto"))}
                                        disabled={true}
                                    />
                                </div>

                                <div className="col-12 mb-20 text-center">
                                    {getValue("estatus") == "E" ?
                                        <span className="bg-success-focus text-success-600 border border-success-main px-24 py-4 radius-4 fw-medium text-sm">
                                            Timbrado
                                        </span> :
                                        (getValue("estatus") == "I" ?
                                            <span className="bg-warning-focus text-warning-600 border border-warning-main px-24 py-4 radius-4 fw-medium text-sm">
                                                Incidencia
                                            </span> :
                                            <span className="bg-info-focus text-info-600 border border-info-main px-24 py-4 radius-4 fw-medium text-sm">
                                                Solicitado
                                            </span>)
                                    }
                                </div>


                                {getValue("estatus") == "I" ? <div className="col-12 mb-20">
                                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                                        Incidencia
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control radius-8"
                                        placeholder="Enter Role  Name"
                                        value={getValue("incidencia")}
                                        disabled={true}
                                    />
                                </div> : ""}


                                <h1 className="modal-title fs-5 mb-10" id="exampleModalLabel">
                                    Descargas
                                </h1>



                                {isXml && <div className="col-4 mb-20">
                                    <a href="#"
                                        onClick={(e) => {
                                            getComprobante("xml", getValue("id"))
                                        }}
                                        className="btn btn-primary-600 text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2" >
                                        <Icon
                                            icon="lucide:code-xml"
                                            className="icon text-xl line-height-1" />
                                        XML
                                    </a>
                                </div>
                                }

                                {isCfdi && <div className="col-4 mb-20">
                                    <a
                                        href="#"
                                        onClick={(e) => {
                                            getComprobante("cfdi", getValue("id"))
                                        }}
                                        className="btn btn-primary-600 text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2" >
                                        <Icon
                                            icon="lucide:receipt-text"
                                            className="icon text-xl line-height-1" />
                                        Factura
                                    </a>
                                </div>
                                }


                                {isRecibo &&
                                    <div className="col-4 mb-20">
                                        <a
                                            href="#"
                                            onClick={(e) => {
                                                getComprobante("recibo", getValue("id"))
                                            }}
                                            className="btn btn-primary-600 text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2" >
                                            <Icon
                                                icon="lucide:receipt"
                                                className="icon text-xl line-height-1" />
                                            Recibo
                                        </a>
                                    </div>
                                }

                                <div className="col-12 mb-20">
                                    <FileViewerModal
                                        isOpen={open}
                                        onClose={() => setOpen(false)}
                                        fileName={fileName}
                                        fileType={fileType}
                                        fileData={exampleBase64PDF}
                                        origen={origen}
                                        s3link={s3Link}
                                    />

                                </div>

                            </div>
                            <div className="text-center mt-24">
                                <button type="button" data-bs-dismiss="modal" className="btn btn-primary px-48 py-12">
                                    Cerrar
                                </button>
                            </div>
                            {/* </form> */}
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}